/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrDataGridAllColumnsModule } from './igr-data-grid-all-columns-module';
import { IgrGridColumnOptionsModule } from './igr-grid-column-options-module';
import { IgrComboBoxColumnModule } from './igr-combo-box-column-module';
import { IgrInputGroupModule } from "igniteui-react-inputs";
import { IgrMultiColumnComboBoxModule } from './igr-multi-column-combo-box-module';
var IgrDataGridModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrDataGridModule() {
    }
    IgrDataGridModule.register = function () {
        IgrDataGridAllColumnsModule.register();
        IgrGridColumnOptionsModule.register();
        IgrComboBoxColumnModule.register();
        IgrInputGroupModule.register();
        IgrMultiColumnComboBoxModule.register();
    };
    return IgrDataGridModule;
}());
export { IgrDataGridModule };
//# sourceMappingURL=igr-data-grid-module.js.map
